import styled from "styled-components";
import { Link } from "react-router-dom";

export const Foot = styled.footer`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 1fr;
  background: #3cc830;
  margin-top: 2rem;
  padding: 5rem 0;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const Logo = styled.h1`
  font-size: 3.2rem;
  font-weight: bold;
  color: #fff;
  margin-left: 2rem;
`;

export const About = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 2.4rem;
  color: #fff;

  h3 {
    font-size: 2.4rem;
    font-weight: bold;
  }
`;
export const Support = styled(About)``;

export const FooterLink = styled(Link)`
  color: #fff;
  font-size: 1.6rem;
  text-decoration: none;

  &:hover {
    color: #005900;
  }
`;
